import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createPricelist,
  fetchAllPricelists,
  updatePricelist,
  fetchOnePricelist,
  deletePricelist,
  uploadPricelist,
  fetchPricelistsByVendor,
  generatePricelistPrintReport,
} from "services/pricelist";

export const useAllPricelists = (filters = {}, options = {}) => {
  const { enabled = true, refetchOnWindowFocus = false } = options;
  return useQuery({
    queryKey: ["all-pricelists", filters],
    queryFn: () => fetchAllPricelists(filters),
    enabled,
    refetchOnWindowFocus
  });
};

export const useOnePricelist = (id) => {
  return useQuery({
    queryKey: ["pricelist", id],
    queryFn: () => fetchOnePricelist(id),
    enabled: Boolean(id),
  });
};

export const useCreatePricelist = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ data }) => createPricelist(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all-pricelists"] });
    },
  });
};

export const useUpdatePricelist = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updatePricelist(id, data),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["all-pricelists"] });
      queryClient.invalidateQueries({ queryKey: ["pricelist", variables.id] });
    },
  });
};

export const useUploadPricelist = () => {
  return useMutation({
    mutationFn: ({ data }) => uploadPricelist(data),
  });
};

export const useDeletePricelist = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deletePricelist(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["all-pricelists"] });
      queryClient.invalidateQueries({ queryKey: ["pricelist", id] });
    },
  });
};

export const usePricelistsByVendor = (vendorId) => {
  return useQuery({
    queryKey: ["vendor-pricelists", vendorId],
    queryFn: () => fetchPricelistsByVendor(vendorId),
    enabled: Boolean(vendorId),
  });
};

export const useGeneratePricelistPrintReport = () => {
  return useMutation({
    mutationFn: (pricelistId) => generatePricelistPrintReport(pricelistId),
  });
};
